// extracted by mini-css-extract-plugin
export default {"main-page":"MainPage_main-page__1-j8c","main-page__container":"MainPage_main-page__container__YRo0L"};